import './App.css'
import React, { useEffect, useState } from 'react'
import LoginPage from './components/LoginPage'
import Cookies from 'js-cookie'

import '../src/styles/tailwind.css'

import Home from './pages/Home'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import '../src/styles/toast.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import NewRegistration from './pages/NewRegistration'
import RenewRegistration from './pages/RenewRegistration'
import { pdfjs } from 'react-pdf'
import ListBerita from './pages/ListBerita'
import moment from 'moment-timezone'
import 'moment/locale/id'
import CreateBerita from './pages/CreateBerita'
import EditBerita from './pages/EditBerita'
import ListBeritaAds from './pages/ListBeritaAds'
import CreateBeritaAds from './pages/CreateBeritaAds'
import EditBeritaAds from './pages/EditBeritaAds'
import ListPertandingan from './pages/ListPertandingan'
import CreatePertandingan from './pages/CreatePertandingan'
import EditPertandingan from './pages/EditPertandingan'
import ListToko from './pages/ListToko'
import CreateToko from './pages/CreateToko'
import EditToko from './pages/EditToko'
import ListVideo from './pages/ListVideo'
import CreateVideo from './pages/CreateVideo'
import EditVideo from './pages/EditVideo'
import SyaratKetentuan from './pages/SyaratKetentuan'
import KebijakanPrivasi from './pages/KebijakanPrivasi'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null)

  useEffect(() => {
    setIsAuthenticated(!!Cookies.get('access_token'))
  }, [])

  useEffect(() => {
    moment.locale('id')
  }, [])

  const handleLogin = () => {
    setIsAuthenticated(true)
  }

  const handleLogout = () => {
    Cookies.remove('access_token', {
      path: '/',
      domain: window.location.hostname,
    })
    Cookies.remove('uuid', {
      path: '/',
      domain: window.location.hostname,
    })
    setIsAuthenticated(false)
  }

  if (isAuthenticated == null) {
    return <></>
  }

  return (
    <div
      className="min-h-screen"
      style={{ maxHeight: '290vw' }}
      id="transaction_data"
    >
      <BrowserRouter>
        {isAuthenticated ? (
          <Routes>
            <Route path="/" element={<Home onLogout={handleLogout} />} />
            <Route path="/konten/berita" element={<ListBerita />} />
            <Route path="/konten/berita/create" element={<CreateBerita />} />
            <Route path="/konten/berita/edit/:id" element={<EditBerita />} />
            {/* <Route path="/konten/berita-ads" element={<ListBeritaAds />} />
            <Route
              path="/konten/berita-ads/create"
              element={<CreateBeritaAds />}
            />
            <Route
              path="/konten/berita-ads/edit/:id"
              element={<EditBeritaAds />}
            /> */}
            <Route path="/new-registration" element={<NewRegistration />} />
            <Route path="/renew-registration" element={<RenewRegistration />} />
            <Route path="/konten/pertandingan" element={<ListPertandingan />} />
            {/* <Route
              path="/konten/pertandingan/create"
              element={<CreatePertandingan />}
            /> */}
            <Route
              path="/konten/pertandingan/edit/:id"
              element={<EditPertandingan />}
            />
            {/* <Route path="/konten/toko" element={<ListToko />} />
            <Route path="/konten/toko/create" element={<CreateToko />} />
            <Route path="/konten/toko/edit/:id" element={<EditToko />} /> */}
            <Route path="/konten/video" element={<ListVideo />} />
            <Route path="/konten/video/create" element={<CreateVideo />} />
            <Route path="/konten/video/edit/:id" element={<EditVideo />} />
            <Route path="/syarat-ketentuan" element={<SyaratKetentuan />} />
            <Route path="/kebijakan-privasi" element={<KebijakanPrivasi />} />
          </Routes>
        ) : (
          // Halaman hukum harus bisa dibuka sebelum masuk, karena tautannya
          // ada di halaman login itu sendiri.
          <Routes>
            <Route path="/syarat-ketentuan" element={<SyaratKetentuan />} />
            <Route path="/kebijakan-privasi" element={<KebijakanPrivasi />} />
            <Route path="*" element={<LoginPage onLogin={handleLogin} />} />
          </Routes>
        )}
      </BrowserRouter>
      <ToastContainer position="top-center" theme="colored" />
    </div>
  )
}

export default App
